<template>
    <div class="search_wrap">
        <el-date-picker
            v-model="date"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
            range-separator=" 至 "
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="small"
            class="mr15"
        ></el-date-picker>
        
        <el-select
            v-model="adSlot"
            filterable
            collapse-tags
            multiple
            clearable
            placeholder="代码位"
            class="select_class mr15"
            size="small"
        >
            <el-option
                v-for="item in adSlotList"
                :key="item.id"
                :label="item.id + ' ' + item.name"
                :value="item.id">
            </el-option>
        </el-select>
        
        <el-input size="small" v-model="productName" placeholder="产品名称" class="input_class mr15"></el-input>
        
        <el-input size="small" v-model="material_id" placeholder="素材ID" class="input_class mr15"></el-input>
        
        <el-input size="small" v-model="keyword" placeholder="素材标题/素材链接" class="input_class mr15"></el-input>
        
        <el-button type="primary" size="small" @click="handleSearchSubmit">查询</el-button>
    </div>
</template>

<script>
import { getReviewCollectionAdslotList } from '@/apis/advCenter.js';
import { getDate } from '@/common/utils';

export default {
    name: 'audit-search',
    data() {
        return {
            date: [],
            choiceDate: '',
            pickerOptions: {
                onPick: ({ maxDate, minDate }) => {
                    this.choiceDate = minDate?.getTime();
                    if (maxDate) this.choiceDate = '';
                },
                disabledDate: (time) => {
                    const today = new Date();
                    today.setHours(0, 0, 0, 0);
                    
                    const todayEnd = new Date(today.getTime() + 24 * 3600 * 1000 - 1);
                    const thirtyOneDaysAgo = new Date(today.getTime() - 31 * 24 * 3600 * 1000);
                    
                    if (time.getTime() < thirtyOneDaysAgo.getTime() || time.getTime() > todayEnd.getTime()) {
                        return true;
                    }
                    
                    if (this.choiceDate) {
                        const oneDay = 24 * 3600 * 1000;
                        const minTime = this.choiceDate - 6 * oneDay;
                        const maxTime = this.choiceDate + 6 * oneDay;
                        return time.getTime() < minTime || time.getTime() > maxTime;
                    }
                    
                    return false;
                }
            },
            adSlotList: [],
            adSlot: [],
            productName: '',
            keyword: '',
            material_id: ''
        }
    },
    
    props: {
        page: String
    },
    
    methods: {
        init() {
            this.date = [getDate(0), getDate(0)]; // 设置今天
            this.getAdSlotList();
        },
        
        // 代码位列表
        async getAdSlotList() {
            let params = {
                type: 'bind',
                page_size: 9999
            };
            const {code, data} = await getReviewCollectionAdslotList(params);
            if (code && code === 200) {
                this.adSlotList = data.list;
            }
        },
        
        // 确认搜索
        handleSearchSubmit() {
            this.$emit('callback', {
                date: this.date,
                adSlotId: this.adSlot,
                productName: this.productName,
                keyword: this.keyword,
                material_id: this.material_id
            });
        }
    },
    
    mounted() {
        this.init();
    }
}
</script>
<style lang="scss">
.el-tag.el-tag--info{max-width: 150px;}
</style>
<style lang="scss" scoped>
.search_wrap{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    & .mr15{margin-right: 15px;}
    & .input_class{
        width: 200px;
    }
    & .select_class{
        width: 240px;
    }
}
</style>
